// Customer-facing title for a page.
//
// Primarily used for the browser tab and history title.
// Ensure new strings are added to 'app-string.json' for localization.

import * as PAGES from 'constants/pages';

export const PAGE_TITLE = {
  // --- Categories ---
  // Dynamically populated in 'window.CATEGORY_PAGE_TITLE'.

  // --- Everything else in alphabetical order ---
  [PAGES.BUY]: 'Buy or Swap',
  [PAGES.CAREERS]: 'Careers',
  [PAGES.CAREERS_IT_PROJECT_MANAGER]: 'Careers - IT Manager',
  [PAGES.CHANNELS]: 'Your channels',
  [PAGES.CHANNELS_FOLLOWING]: 'Following',
  [PAGES.CHANNELS_FOLLOWING_DISCOVER]: 'Discover Channels',
  [PAGES.CHANNEL_NEW]: 'Create a channel',
  [PAGES.CHECKOUT]: 'Checkout',
  [PAGES.CODE_2257]: '2257',
  [PAGES.CREATOR_DASHBOARD]: 'Creator Analytics',
  [PAGES.FYP]: 'Recommended Videos (Alpha)',
  [PAGES.HELP]: 'Help',
  [PAGES.INVITE]: 'Invite',
  [PAGES.LIBRARY]: 'Purchases',
  [PAGES.LISTS]: 'Playlists',
  [PAGES.PLAYLISTS]: 'Playlists',
  [PAGES.LIVESTREAM]: 'Go Live on Odysee',
  [PAGES.LIVESTREAM_CURRENT]: 'Live (Experimental)',
  [PAGES.NOTIFICATIONS]: 'Notifications',
  [PAGES.ODYSEE_MEMBERSHIP]: 'Odysee Premium',
  [PAGES.CREATOR_MEMBERSHIPS]: 'Creator Memberships',
  [PAGES.POST]: 'Post an Article on Odysee',
  [PAGES.PRIVACY_POLICY]: 'Privacy Policy',
  [PAGES.RECEIVE]: 'Your address',
  [PAGES.REPORT]: 'Report an issue or request a feature',
  [PAGES.REPORT_CONTENT]: 'Report content',
  [PAGES.REPOST_NEW]: 'Repost',
  [PAGES.REWARDS]: 'Credits',
  [PAGES.REWARDS_VERIFY]: 'Verify to receive Credits',
  [PAGES.SEARCH]: 'Search',
  [PAGES.SEND]: 'Send Credits',
  [PAGES.SETTINGS]: 'Settings',
  [PAGES.SETTINGS_BLOCKED_MUTED]: 'Blocked and muted channels',
  [PAGES.SETTINGS_CREATOR]: 'Creator settings',
  [PAGES.SETTINGS_NOTIFICATIONS]: 'Manage notifications',
  [PAGES.SETTINGS_OWN_COMMENTS]: 'Your comments',
  [PAGES.SETTINGS_STRIPE_ACCOUNT]: 'Bank Accounts',
  [PAGES.SETTINGS_STRIPE_CARD]: 'Payment Methods',
  [PAGES.SETTINGS_UPDATE_PWD]: 'Update password',
  [PAGES.SWAP]: 'Swap Credits',
  [PAGES.TAGS_FOLLOWING]: 'Tags',
  [PAGES.TAGS_FOLLOWING_MANAGE]: 'Manage tags',
  [PAGES.TOS]: 'Terms of Service',
  [PAGES.UPLOADS]: 'Your uploads',
  [PAGES.UPLOAD]: 'Upload a File to Odysee',
  [PAGES.WALLET]: 'Wallet',
  [PAGES.YOUTUBE_SYNC]: 'YouTube Sync',
  [PAGES.YOUTUBE_TOS]: 'YouTube Sync Terms of Service',
};
